var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.734 57.5723V24.3456C74.734 20.949 72.9284 17.809 70.0027 16.1106L45.6521 1.99348C42.7222 0.295143 39.1152 0.295143 36.1895 1.99348L11.8431 16.1106C8.9132 17.809 7.11182 20.949 7.11182 24.3456V57.5723C7.11182 60.9689 8.91746 64.1089 11.8431 65.8073L36.1895 79.9287C39.1194 81.627 42.7264 81.627 45.6521 79.9287L69.9985 65.8073C72.9284 64.1089 74.7298 60.9689 74.7298 57.5723H74.734Z",
    fill: "#3E57FE"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M74.5811 41.7609C62.3291 43.8699 50.0814 45.9575 37.8592 48.2591C31.5778 49.4441 25.2921 50.5306 18.9638 51.4247C15.0119 51.9851 11.0514 52.507 7.10791 53.1402V57.5678C7.10791 60.9645 8.91355 64.1045 11.8392 65.8028L36.1856 79.9243C39.1155 81.6226 42.7225 81.6226 45.6482 79.9243L69.9946 65.8028C72.9245 64.1045 74.7259 60.9645 74.7259 57.5678V41.731C74.6748 41.7395 74.6237 41.7481 74.5768 41.7566L74.5811 41.7609Z",
    fill: "url(#paint0_radial_3537_6944)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0659 57.7818L10.544 65.8029C5.14832 66.4745 0.387207 62.248 0.387207 56.785C0.387207 52.1991 3.78982 48.3319 8.32097 47.7672L72.8429 39.7461C78.2386 39.0744 82.9997 43.301 82.9997 48.7639C82.9997 53.3499 79.5971 57.2171 75.0659 57.7818Z",
    fill: "#FFEC9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6787 58.1707L10.1567 66.1918C4.76111 66.8635 0 62.6369 0 57.174C0 52.588 3.40262 48.7208 7.93376 48.1561L72.4557 40.135C77.8514 39.4634 82.6125 43.6899 82.6125 49.1529C82.6125 53.7388 79.2099 57.606 74.6787 58.1707Z",
    fill: "#FEB72D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3537_6944",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4365 60.1681) rotate(-5.67548) scale(33.5038 11.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#808E95",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#88959C",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#96A1A7",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#AAB3B8",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C3CACD",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E2E5E6",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/OBJECTS.bdc4579c7a6098f56a676504c7d7416a.svg";
export { ForwardRef as ReactComponent };